var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.25V15.9141C11.8741 16.0179 11.8993 16.1204 11.9485 16.2119C11.9977 16.3034 12.0691 16.381 12.1563 16.4375L13.0157 17.0078C13.0989 17.0634 13.1943 17.0982 13.2938 17.1092C13.3933 17.1202 13.494 17.1072 13.5874 17.0712C13.6808 17.0352 13.7642 16.9774 13.8306 16.9024C13.8969 16.8275 13.9443 16.7377 13.9688 16.6406L15 12.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4999C15.8288 12.4999 16.6237 12.1707 17.2097 11.5846C17.7958 10.9986 18.125 10.2037 18.125 9.37493C18.125 8.54613 17.7958 7.75127 17.2097 7.16522C16.6237 6.57917 15.8288 6.24993 15 6.24993H11.875C11.875 6.24993 7.61719 6.24993 3.52344 2.82024C3.43238 2.74489 3.32183 2.69691 3.20461 2.68185C3.08738 2.66679 2.96829 2.68528 2.86115 2.73517C2.75401 2.78506 2.66321 2.86431 2.59929 2.96372C2.53536 3.06313 2.50094 3.17862 2.5 3.29681V15.4531C2.50094 15.5712 2.53536 15.6867 2.59929 15.7861C2.66321 15.8856 2.75401 15.9648 2.86115 16.0147C2.96829 16.0646 3.08738 16.0831 3.20461 16.068C3.32183 16.053 3.43238 16.005 3.52344 15.9296C7.61719 12.4999 11.875 12.4999 11.875 12.4999H15Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/Campaigns.3becc81263f4167e2bc58fd3dc1a9196.svg";
export { ForwardRef as ReactComponent };